import {Params} from '@feathersjs/feathers'

import {Material} from '../../types'

import * as feathersService from '../feathers'

export const RESOURCE = 'material'

export const get = async (params?: Params) => feathersService.find<Material>(RESOURCE, params)

export const getByDefaultOrderWithTagsAndPrintingMethodsAndAppIds = async () => {
  const params = {
    query: {
      $modify: 'defaultOrder,includeTags,includePrintingMethods,includeApps,includeProviders',
    },
  }

  return get(params)
}
